module.exports = __webpack_public_path__ + "img/Wp_2027.6dc17850.png";